(() => {
  const root = document.getElementById('hsfs');
  const stage = document.getElementById('hsfsScratch');
  const canvas = document.getElementById('hsfsScratchCanvas');
  const card = document.getElementById('hsfsScratchCard');
  if (!root || !stage || !canvas || !card || canvas.dataset.ready) return;
  canvas.dataset.ready = '1';
  let ctx;
  try { ctx = canvas.getContext('2d'); } catch (_) {}
  if (!ctx) { root.classList.add('is-scratch-unavailable'); return; }

  const columns = 40;
  const rows = 28;
  const cleared = new Uint8Array(columns * rows);
  const lines = [];
  let clearedCount = 0;
  let width = 0;
  let height = 0;
  let pointer = null;
  let last = null;
  let revealed = false;
  let resizeFrame;
  let revealTimer;
  let artStarted = false;
  let destroyed = false;
  const artwork = [];

  function loadArtwork() {
    if (artStarted || !window.Image) return;
    artStarted = true;
    const images = window.HSRollonImages || {};
    [
      ['intenso-roma-sample', 'https://cdn.shopify.com/s/files/1/0692/8796/8883/files/hs-rollon-intenso-roma-2026.png?v=1790970098'],
      ['imagine-sample', 'https://cdn.shopify.com/s/files/1/0692/8796/8883/files/hs-rollon-imagine-2026.png?v=1790969885'],
      ['paradoxal-sample', 'https://cdn.shopify.com/s/files/1/0692/8796/8883/files/hs-rollon-paradoxal-2026.png?v=1790970017'],
      ['bakarouge-540-sample', 'https://cdn.shopify.com/s/files/1/0692/8796/8883/files/hs-rollon-rouge-640-2026.png?v=1790969950']
    ].forEach(([handle, fallback], index) => {
      const image = new window.Image();
      artwork[index] = image;
      image.decoding = 'async';
      image.onload = () => paint(true);
      const source = new URL(images[handle] || fallback, location.origin);
      source.searchParams.set('width', '600');
      image.src = source.href;
    });
  }

  function drawSample(index, x, y, size, rotation) {
    const image = artwork[index];
    if (!image || !image.complete || !image.naturalWidth) return;
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(rotation * Math.PI / 180);
    ctx.shadowColor = 'rgba(62, 18, 116, .14)';
    ctx.shadowBlur = size * .045;
    ctx.shadowOffsetY = size * .035;
    const scale = Math.min(size / image.naturalWidth, size / image.naturalHeight);
    const w = image.naturalWidth * scale;
    const h = image.naturalHeight * scale;
    ctx.drawImage(image, -w / 2, -h / 2, w, h);
    ctx.restore();
  }

  function erase(a, b) {
    ctx.globalCompositeOperation = 'destination-out';
    ctx.lineWidth = Math.min(width, height) * .23;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.beginPath();
    ctx.moveTo(a.x * width, a.y * height);
    ctx.lineTo(b.x * width, b.y * height);
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(b.x * width, b.y * height, ctx.lineWidth / 2, 0, Math.PI * 2);
    ctx.fill();
  }

  function paint(force = false) {
    if (destroyed || !root.isConnected || stage.hidden || revealed || !root.classList.contains('is-open')) return;
    const nextWidth = canvas.clientWidth;
    const nextHeight = canvas.clientHeight;
    if (!nextWidth || !nextHeight || (!force && width === nextWidth && height === nextHeight)) return;
    width = nextWidth;
    height = nextHeight;
    const ratio = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(width * ratio);
    canvas.height = Math.round(height * ratio);
    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
    ctx.globalCompositeOperation = 'source-over';
    const foil = ctx.createLinearGradient(0, 0, width * .3, height);
    foil.addColorStop(0, '#c59bf6');
    foil.addColorStop(.46, '#b7b9f6');
    foil.addColorStop(1, '#68e3e8');
    ctx.fillStyle = foil;
    ctx.fillRect(0, 0, width, height);
    loadArtwork();
    const large = Math.min(width * .75, height * .35);
    const small = large * .84;
    drawSample(0, width * .12, height * .73, large, -40);
    drawSample(2, width * .88, height * .73, large, -9);
    drawSample(1, width * .25, height * .855, small, -7);
    drawSample(3, width * .75, height * .87, small, -43);
    ctx.fillStyle = '#000';
    ctx.strokeStyle = '#000';
    lines.forEach(line => erase(line[0], line[1]));
  }

  function reveal() {
    if (revealed) return;
    revealed = true;
    pointer = null;
    card.classList.add('is-revealed');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    revealTimer = window.setTimeout(() => {
      if (destroyed || !root.isConnected || !root.classList.contains('is-open')) return;
      stage.classList.add('is-leaving');
      revealTimer = window.setTimeout(() => {
        if (!destroyed && root.isConnected) root.dispatchEvent(new CustomEvent('hsfs:scratch-revealed'));
      }, reduced ? 0 : 340);
    }, reduced ? 0 : 500);
  }

  function mark(a, b) {
    const ax = a.x * width, ay = a.y * height;
    const bx = b.x * width, by = b.y * height;
    const dx = bx - ax, dy = by - ay;
    const length = dx * dx + dy * dy;
    const radius = Math.min(width, height) * .115;
    for (let row = 0; row < rows; row++) {
      for (let col = 0; col < columns; col++) {
        const i = row * columns + col;
        if (cleared[i]) continue;
        const x = (col + .5) / columns * width;
        const y = (row + .5) / rows * height;
        const t = length ? Math.max(0, Math.min(1, ((x - ax) * dx + (y - ay) * dy) / length)) : 0;
        if ((x - ax - t * dx) ** 2 + (y - ay - t * dy) ** 2 <= radius ** 2) {
          cleared[i] = 1;
          clearedCount++;
        }
      }
    }
    if (clearedCount / cleared.length >= .38) reveal();
  }

  function point(event) {
    const rect = canvas.getBoundingClientRect();
    return { x: Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width)), y: Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height)) };
  }

  canvas.addEventListener('pointerdown', event => {
    if (revealed || stage.hidden || pointer !== null || !root.classList.contains('is-open') || (event.pointerType === 'mouse' && event.button !== 0)) return;
    event.preventDefault();
    paint();
    pointer = event.pointerId;
    try { canvas.setPointerCapture(pointer); } catch (_) {}
    card.classList.add('is-scratching');
    last = point(event);
    lines.push([last, last]);
    erase(last, last);
    mark(last, last);
  });

  canvas.addEventListener('pointermove', event => {
    if (event.pointerId !== pointer || revealed || stage.hidden) return;
    event.preventDefault();
    const next = point(event);
    lines.push([last, next]);
    erase(last, next);
    mark(last, next);
    last = next;
  });

  function stop(event) {
    if (event.pointerId !== pointer) return;
    try { if (canvas.hasPointerCapture(pointer)) canvas.releasePointerCapture(pointer); } catch (_) {}
    pointer = null;
    last = null;
  }
  ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(name => canvas.addEventListener(name, stop));
  root.addEventListener('hsfs:scratch-start', () => requestAnimationFrame(paint));
  root.addEventListener('hsfs:scratch-stop', () => {
    if (pointer !== null) {
      try { if (canvas.hasPointerCapture(pointer)) canvas.releasePointerCapture(pointer); } catch (_) {}
    }
    pointer = null; last = null;
    clearTimeout(revealTimer);
    if (revealed) root.dispatchEvent(new CustomEvent('hsfs:scratch-revealed'));
  });
  root.addEventListener('hsfs:scratch-skip', () => {
    revealed = true;
    clearTimeout(revealTimer);
    pointer = null;
  });
  const observer = window.ResizeObserver ? new ResizeObserver(() => {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(paint);
  }) : null;
  if (observer) observer.observe(canvas);
  requestAnimationFrame(paint);
  root.addEventListener('hsfs:destroy', () => {
    destroyed = true;
    if (observer) observer.disconnect();
    clearTimeout(revealTimer);
    cancelAnimationFrame(resizeFrame);
    artwork.forEach(image => { image.onload = null; });
  }, {once: true});
})();

